/**
 * Returns all unique values of an array, based on a provided comparator function.
 *
 * @param {Object} arr Array of elements
 * @param {Function} fn Comparation function. Defautl is identity
 *
 * @returns {Object} Array
 */

const identity = (v) => v

// Font: https://www.30secondsofcode.org/js/s/unique-elements-by/
const uniqueElementsBy = (arr, fn = identity) =>
  arr.reduce((acc, v) => {
    if (!acc.some((x) => fn(v, x))) acc.push(v)
    return acc
  }, [])

export default uniqueElementsBy
